export const Paths = {
  internalDashboard: { path: "/internal/dashboard", title: "Dashboard" },
  userManagement: { path: "/user/management", title: "User Management" },
  licenseVerification: { path: "/license/list", title: "License Verification" },
  partnerDashboard: {
    path: "/partner/dashboard/:id?",
    title: "Dashboard",
    subUserAllowed: true,
  },
  neValidation: { path: "/approval/neValidation", title: "NE Validation" },
  ticketTracker: { path: "/ticket/tracker", title: "Ticket Tracker" },
  addUser: { path: "/add/user", title: "Add User" },
  editUser: { path: "/edit/user", title: "Edit User" },
  approvalScreen: { path: "/approval", title: "License Approval" },
  neApproval: { path: "/approval/neApproval", title: "NE Approval" },
  bulkUpload: { path: "/configuration/bulkUpload", title: "Bulk Upload" },
  partnerFeedback: { path: "/feedback/list", title: "Partner Misconduct" },
  addFeedback: { path: "/add/feedback", title: "Add Feedback" },
  statusScreen: { path: "/partner/status/:id?", title: "Partner Status" },
  prospectEvaluation: {
    path: "/profile/prospectEvaluation",
    title: "Prospect Evaluation Engine",
  },
  prospectEvaluatePartner: {
    path: "/profile/evaluatePartner",
    title: "Evaluate Partner Profile",
  },
  addprospect: { path: "/profile/addProspect", title: "Add Prospect" },
  editProspect: { path: "/profile/editProspect", title: "Edit Prospect" },
  addLCOPartnership: { path: "/add/partnership", title: "Add Partnership" },
  addLicense: { path: "/partner/add/license", title: "Add License" },
  viewLcoDashboard: {
    path: "/dashboard/ViewLcoDashboard",
    title: "View LCO Dashboard",
  },
  polygonCreation: { path: "/edit/polygon", title: "Edit Polygon" },
  partnerDashboardDetails: {
    path: "/partner/dashboard/details",
    title: "Dashboard Details",
    type: "tabs",
    subUserAllowed: true,
  },
  partnerTicketTracker: {
    path: "/partner/ticket/tracker",
    title: "Ticket Tracker",
  },
  cart: { path: "/partner/cart", title: "Cart" },
  commissionSummary: {
    path: "/partner/summaryCommission",
    title: "Commission Summary",
  },
  manageTeam: {
    path: "/partner/dashboard/manage/team",
    title: "Manage Team",
    type: "tabs",
  },
  ironMan: {
    path: "/partner/inActiveBase",
    title: "Inactive Base",
    subUserAllowed: true,
  },
  manageOrders: { path: "/partner/manage/orders", title: "Manage Orders" },
  orderDetail: { path: "/partner/order/detail", title: "Order Detail" },
  updateOrder: { path: "/update/order", title: "Update Order" },
  masterConfig: {
    path: "/configuration/master",
    title: "Master Configuration",
  },
  airtelAmbassador: {
    path: "/partner/airtelAmbassador",
    title: "Airtel Ambassador",
  },
  addEmployee: {
    path: "/partner/dashboard/addEmployee",
    title: "Add Employee",
  },
  changePassword: {
    path: "/partner/changePassword",
    title: "Change Password",
  },
  policyVerification: {
    path: "/insurance/list",
    title: "Insurance Verification",
  },
  orderInstallments: {
    path: "/partner/order/installments",
    title: "Installments",
  },
  manageInvoices: { path: "/partner/manage/invoices", title: "Invoices" },
  customerDownTime: {
    path: "/partner/myNetwork/CDT",
    adminPath: "/CDT",
    title: "Customer Down Time",
  },
  CDTDetails: {
    path: "/partner/myNetwork/CDTDetails",
    adminPath: "/CDT/Details",
    title: "Customer Down Time",
  },
  insuredUsers: {
    path: "/vendor/insured/users",
    title: "Insured Users",
  },
  vendorLogin: {
    path: "/login",
  },
  vendorFogotPassword: {
    path: "/forgot-password",
  },
  fnfInitiate: {
    path: "/fnf/initiate/terminate",
    title: "Initiate FnF"
  },
  scmLogin: {
    path: "/scm",
    title: "SCM Login",
  },
  scmDashboard: {
    path: "/scm/dashboard",
    title: "SCM Dashboard",
  },
  scmProductCatalog: {
    path: "/scm/product/catalog",
    title: "Product Catalog",
  },
  scmCart: {
    path: "/scm/cart",
    title: "Cart",
  },
  productDetail: { path: "/scm/product", title: "Product Info" },
  scmOrders: {
    path: "/scm/orders",
    title: "My Orders",
  },
  scmBulkUpload: {
    path: "/scm/catalog/bulk/upload",
    title: "Catalog Bulk Upload",
  },
   scmManageCatalog: {
    path: "/scm/catalog/manage",
    title: "Manage Catalog",
  },
  widget: {
    path: "/partner/omni/widget/",
    title: "Omni Widget",
  },
};
